// What a screen says when the home it belongs to is switched off for this business (Stage 4.2b O1b step 7) — reached
// only from a link or a remembered page, since the menu no longer offers it. Said plainly, with the way back for the
// owner, rather than a blank page that looks like a fault.
import React from "react";
import { useTranslation } from "react-i18next";
import { Lock } from "lucide-react";
import EmptyState from "../../../design-system/components/EmptyState";

export default function ModuleOff({ module, owner = false, onOpen }) {
  const { t } = useTranslation("business");
  return (
    <EmptyState
      icon={<Lock size={26} />}
      title={t("moduleOffTitle", { module: t(`module_${module}`) })}
      description={owner ? t("moduleOffOwner") : t("moduleOffStaff")}
      action={owner && onOpen ? { label: t("openBusiness"), onClick: onOpen } : undefined}
    />
  );
}
